/* @flow */
import Helmet from 'react-helmet'
import React from 'react'
import PropTypes from 'prop-types'

const Title = ({ message, isStandalone }: any) => {
  const suffix = isStandalone ? '' : ' | Vobo'
  return (
    <Helmet title={`${message}${suffix}`} />
  )
}

Title.defaultProps = {
  values: {},
  isStandalone: false,
}

Title.propTypes = {
  message: PropTypes.string.isRequired,
  values: PropTypes.object,
  isStandalone: PropTypes.bool,
}

export default Title



// WEBPACK FOOTER //
// ./src/browser/components/Title.js